var Adapter;

Adapter = (function() {
  function Adapter() {}

  Adapter.get = function(model, key) {
    if (key) {
      return model[key];
    }
    return model;
  };

  Adapter.id = function(model) {
    var id;
    id = this.get(model, 'id');
    if (id === void 0) {
      return id;
    }
    return "" + id;
  };

  return Adapter;

})();

module.exports = Adapter;



//////////////////
// WEBPACK FOOTER
// ./node_modules/yayson/lib/yayson/adapter.js
// module id = 0Hx0
// module chunks = 3